import {
  DomainName,
  ITextInputControl,
  StringDomain,
  TControlName,
} from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../../infrastructure/providers/abstract/IApiProvider';
import {
  FormControlViewModelType,
  LocalizedProps,
  TextInputFormControlViewModel,
} from '../../view-model/FormControlViewModel';
import { FormSourceType } from '../../view-model/FormSource';
import { FormViewModel } from '../../view-model/FormViewModel';

import {
  controlDomain,
  getControlValueHistory,
  getValueFromArgsOrConfig,
} from './helpers';

const buildTextInputControl = async (
  item: ITextInputControl,
  viewModel: FormViewModel,
  localizedProps: LocalizedProps,
  args: TActionArgsValues,
  domains: Array<{ name: TControlName; domain: DomainName }>
): Promise<TextInputFormControlViewModel> => {
  const domain = (await controlDomain(
    item,
    viewModel.source,
    domains
  )) as StringDomain;

  return {
    columns: item.columns,
    type: FormControlViewModelType.TEXT_INPUT,
    maskPassword: !!item.maskPassword,
    name: item.name,
    noLabel: item.noLabel,
    labelWidth: item.labelWidth,
    lengthInBytes: domain.lengthInBytes,
    maxLength: domain.length,
    hasValue: true,
    hasHistory: !item.maskPassword,
    value: getValueFromArgsOrConfig(item, args, viewModel.source, ''),
    required: item.required,
    history: item.maskPassword
      ? []
      : getControlValueHistory(viewModel.source, item.name),
    updater: item.updater,
    storeValue: item.maskPassword ? false : item.storeValue,
    disabled: item.disabled,
    visible: item.visible,
    readonly: item.readonly,
    enableButtonOnReadOnly: viewModel.source.type !== FormSourceType.REVIEW,
    trim: item.trim,
    invalid: item.invalid,
    errorMessage: item.errorMessage,
    regExp:
      item.regExp ??
      (domain.regExp ? new RegExp(domain.regExp, 'g') : undefined),
    placeholder: item.placeholder,
    ...localizedProps,
  };
};

export default buildTextInputControl;
